import { skipToken, useQuery } from '@tanstack/react-query'

import type { UseQueryResult } from '@tanstack/react-query'
import type { IAdvancedFilters, IASOAdvanced, IASOKeyword } from '~/types/aso'

import { getASOKeywordsAdvanced, getASOKeywordsOverview } from '~/api/application-aso'

////////// KEYS //////////
export const keys = {
  advanced: ({ appId, filters }: { appId?: string; filters: IAdvancedFilters }) =>
    ['asoAdvanced', appId, filters] as const,
  overview: (appId?: string) => ['asoOverview', appId] as const,
}

export const useASOKeywordOverview = (appId?: string): UseQueryResult<IASOKeyword[], unknown> => {
  return useQuery({
    queryFn: appId ? () => getASOKeywordsOverview(appId) : skipToken,
    queryKey: keys.overview(appId),
  })
}

export const useASOAdvanced = ({
  appId,
  filters,
}: {
  appId?: string
  filters: IAdvancedFilters
}): UseQueryResult<IASOAdvanced, unknown> => {
  return useQuery({
    queryFn: appId && filters.cluster_id ? () => getASOKeywordsAdvanced({ appId, filters }) : skipToken,
    queryKey: keys.advanced({ appId, filters }),
  })
}
